import { getConfigFromApp } from 'config';
import * as _ from 'lodash';

export function isFacilityEligibleCheckEnalbled() {
  const config = getConfigFromApp();
  return (
    !_.isNil(config.eligibleFacilityPermitNumber) &&
    !_.isNil(config.eligibleFacilityEiaNumber) &&
    !_.isNil(config.eligibleFacilityEmissionNumber)
  );
}

export function isFacilityEiaEligible(facility) {
  const config = getConfigFromApp();
  return (
    facility.facilityeias.length >= (+config.eligibleFacilityEiaNumber || 0)
  );
}

export function isFacilityEmissionEligible(facility) {
  const config = getConfigFromApp();
  return (
    facility.facilityemissions.length >=
    (+config.eligibleFacilityEmissionNumber || 0)
  );
}

export function isFacilityPermitEligible(facility) {
  const config = getConfigFromApp();
  return (
    facility.facilitypermits.length >=
    (+config.eligibleFacilityPermitNumber || 0)
  );
}



// WEBPACK FOOTER //
// ./src/utils/facilityUtil.js